<template>
  <div style="height: 100%" class="bom">
    <SplitContainer2 style="height:100%" layout="horizontal" :split_setting="0.5">
      <template #table1>
        <TableMain name="one table" ref="PreDistributionApplyTable1" :fields="fields1" :title="table_title.title1"
          :date_picker_label="''" :query_button_label="query_lable" :show_query_container="true"
          :show_toolbar_container="true" :show_pagination_container="true" :show_date_picker="false"
          :show_toolbar="true" :show_toolbar_state="false" :show_filter="true" :isBusy="isBusy"
          :table_height_adjust="-6" :show_toolbar_button="[0, 0, 1, 1, 1]" @current_changed="current_changed"
          @state_change="state_change" @on_query="on_query" @on_cell_button_click="on_cell_button_click"
          :hb_table_class="'hb_table_pre_distri_apply_class1'" tableref="77c580fd0a54492fb54a7df1a01bf934">
          <template #query>
            物料编号：<el-input clearable size="small" style="width: 180px" v-model="ItemId"></el-input>
            物料名称：<el-input clearable size="small" style="width: 180px" v-model="NameAlias"></el-input>
          </template>
          <template #toolbar>
            <el-button type="info" plain @click="isShowDrawer = true" class="ml-2 iconfont icon-add-new" size="mini">
              {{ $t("common.new") }}
            </el-button>
            <el-popover placement="right" title="提示" width="220" trigger="hover">
              <p>1、附件请在数据创建后上传；</p>
              <p>2、已审批数据不能编辑附件；</p>
              <i slot="reference" class="el-icon-question ml-2" style="font-size:18px;margin-top: 6px;"></i>
            </el-popover>
          </template>
        </TableMain>
      </template>
      <template #table2>
        <TableMain ref="PreDistributionApplyTable2" :fields="fields2" :show_query_container="false"
          :title="table_title.title2" :date_picker_label="date_picker_label" :table_height_adjust="10"
          :show_pagination="false" :show_toolbar="true" :show_toolbar_state="false" :show_filter="false"
          :pager_count="5" :isBusy="isBusy4" @state_change="edit_state_change" @on_input="edit_distribution_on_input"
          :show_toolbar_button="[0, 0, 0, 0, 1]" tableref="4fcf859c5ee94fcf968d6cef68103a4a">
          <template #toolbar>
            供应商：<el-select size="small" v-model="MainSelectedAccountNumData" multiple filterable remote reserve-keyword
              collapse-tags :remote-method="VendersRemoteMethod" clearable @clear="VendersRemoteMethod('')"
              @focus="VendersRemoteMethod('')" placeholder="请输入供应商关键词" style="width:400px;">
              <el-option v-for="(t, k) in VendersOptions" :key="k" :label="t.label" :value="t.value"></el-option>
            </el-select>
            <el-button type="info" plain style="width: 55px" class="ml-2" @click="MainAddVendInto"><i
                class="fa fa-plus"></i></el-button>
          </template>
          <template #operation>
            描述：<el-input clearable size="small" style="width: 20rem" v-model="MainApplyDescription"></el-input>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="MainSaveData"
              :label="$t('common.save')" class="ml-2"></QueryButton>
          </template>
        </TableMain>
      </template>
    </SplitContainer2>
    <el-drawer :size="'70%'" :visible.sync="isShowDrawer" :direction="'rtl'" :modal="false">
      <template slot="title">
        <span>新建预分配</span>
      </template>
      <div>
        <SplitContainer21 style="height:100%" :layout="12" :split_setting="0.5">
          <template #top>
            <TableMain ref="PreDistributionApplyTable3" :show_query_container="false" :show_date_picker="false"
              :fields="valid_pre_distribution_fields" :table_height_adjust="10" :title="table_title.title3"
              :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_toolbar="false"
              :show_toolbar_state="false" :pager_count="5" :isBusy="isBusy2" :check_state="true"
              :hb_table_class="'hb_table_pre_distri_apply_class2'" @current_changed="getPreDetail"
              tableref="28a1d19560c249efa2712bafd27c6d02">
              <template #toolbar>
                物料编号：<el-input clearable size="small" style="width: 180px" v-model="ItemId"></el-input>
                物料名称：<el-input clearable size="small" style="width: 180px" v-model="NameAlias"></el-input>
                <el-button type="primary" @click="QueryPreDistribution" class="ml-2 iconfont icon-search" size="mini">
                  {{ $t("common.query") }}
                </el-button>
              </template>
            </TableMain>
          </template>
          <template #bottom>
            <TableMain ref="PreDistributionApplyTable4" :fields="distribution_fields" :show_query_container="false"
              :title="table_title.title4" :date_picker_label="date_picker_label" :table_height_adjust="2"
              :show_pagination="true" :show_toolbar_state="false" :show_filter="false" :pager_count="5"
              :isBusy="isBusy3" @state_change="new_state_change" :show_toolbar_button="[0, 0, 0, 0, 1]"
              @on_input="distribution_on_input" tableref="f949935b6ed64917b0e3124df8f4fa21">
              <template #toolbar>
                供应商：<el-select size="small" v-model="SelectedAccountNumData" multiple filterable remote reserve-keyword
                  collapse-tags :remote-method="VendersRemoteMethod" clearable @clear="VendersRemoteMethod('')"
                  @focus="VendersRemoteMethod('')" placeholder="请输入供应商关键词" style="width:400px;">
                  <el-option v-for="(t, k) in VendersOptions" :key="k" :label="t.label" :value="t.value"></el-option>
                </el-select>
                <el-button type="info" plain style="width: 55px" class="ml-2" @click="AddVendInto"><i
                    class="fa fa-plus"></i></el-button>
              </template>
              <template #operation>
                描述：<el-input clearable size="small" style="width: 20rem" v-model="ApplyDescription"></el-input>
                <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="SaveData"
                  :label="$t('common.save')" class="ml-2"></QueryButton>
              </template>
            </TableMain>
          </template>
        </SplitContainer21>
      </div>
    </el-drawer>
    <!-- 附件 -->
    <el-dialog title="附件管理" :visible.sync="accessoryVisible" width="60%" :top="'5vh'" :close-on-click-modal="false"
      @opened="dialogOpened">
      <FileUpload ref="refAccessory" :accessoryCategory="'ConsultQuote'" :showUpload="isShowUpload"
        @setAccessory="setAccessory">
      </FileUpload>
    </el-dialog>
  </div>
</template>

<script>
import * as commonController from "../../controllers/commonController"
import * as PreDistributionController from "../../controllers/sd/PreDistributionController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import QueryButton from "../components/base/QueryButton"
import SplitContainer2 from "../components/container/SplitContainer2"
import SplitContainer21 from "../components/container/SplitContainer21"
import BaseModal from "../components/modals/baseModal"
import TableMain from "../components/table/TableMain"
import FileUpload from "../FileUpload.vue"

export default {
  components: {
    SplitContainer2,
    SplitContainer21,
    TableMain,
    QueryButton,
    BaseModal,
    FileUpload
  },
  data() {
    return {
      isShowDrawer: false,
      date_picker_label: "",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "预分配变更申请列表",
        title2: "预分配变更申请明细",
        title3: "有效预分配列表",
        title4: "预分配变更申请明细",
      },
      fields1: _.cloneDeep(PreDistributionController.fields.apply),
      fields2: _.cloneDeep(PreDistributionController.fields.detail),
      valid_pre_distribution_fields: _.cloneDeep(PreDistributionController.fields.default),
      distribution_fields: _.cloneDeep(PreDistributionController.fields.detail_add),
      dataAreaId: "070",//销售公司编号
      MainSelectedAccountNumData: [],//供应商编号
      SelectedAccountNumData: [],//供应商编号
      isBusy: false,
      isBusy2: false,
      isBusy3: false,
      isBusy4: false,
      ItemId: "",
      NameAlias: "",
      VendersOptions: [],
      MainApplyDescription: "",
      ApplyDescription: "",
      current_accessory: null, ///当前派单选中附件
      accessoryVisible: false,
      all_role_users: [],
      isShowUpload: true,
    }
  },
  async created() {
    // _.each(this.fields2, (t) => { delete t.editable; delete t.type; })
    this.valid_pre_distribution_fields = _.filter(this.valid_pre_distribution_fields, (t) => {
      return t.key != "fcCheckDocumentApproved" && t.key != "fcGetDocumentApprover"
    })
    await this.getAllRoleUsers()
  },
  mounted() {

  },
  methods: {
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    //#region 预分配
    async on_query(set_data, isLoading = true) {
      this.ItemId = _.trim(this.ItemId)
      this.NameAlias = _.trim(this.NameAlias)
      if (isLoading) {
        this.isBusy = true
        set_data([])
      }
      let p = { is_deleted: { "=": 0 } }
      if (this.ItemId != "") p.ItemId = { "=": this.ItemId }
      if (this.NameAlias != "") p.NameAlias = { "like": "%" + this.NameAlias + "%" }
      let _result = await PreDistributionController.methods.getPreDistributionApply(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.cloneDeep(_result[0])
        _.each(dt, (t) => {
          this.getApprover(t)
          t.AccessoryCount = 0
          if (t.Accessory && t.Accessory != "")
            t.AccessoryCount = JSON.parse(t.Accessory).length
        })
        set_data(_.orderBy(dt, ["id"], ["desc"]))
      }

      this.$refs.PreDistributionApplyTable2.SetData([])
      this.isBusy = false
    },
    getApprover(t) {
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "fcGetDocumentApprover",
        "fcGetDocumentApprover",
        t.fcCheckDocumentApproved
      )
    },
    current_changed(old, current) {
      if (current) {
        this.MainApplyDescription = current.Description
        if (current.DistributionJson && current.DistributionJson != "") {
          let dt = JSON.parse(current.DistributionJson)
          this.$refs.PreDistributionApplyTable2.SetData(dt)
        }
      }
    },
    async state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      let v = await this.msgModal(this.$t("notify.is_continue"))
      if (!v) { cb(false); return }
      let p = {}, renew_dt = []
      if (data.state === "deleted") {
        let is_del_ok = _.findIndex(data.selected_items, { fcCheckDocumentApproved: true }) > -1
        if (is_del_ok) {
          this.msgToasts("已审批数据不能被删除！", "info")
          cb(false)
          return
        }
        p = { delete: data.selected_items }
      }
      else if (data.state === "approved" || data.state === "unapproved") {
        let dt = _.filter(data.selected_items, (t) => { return t.fcCheckDocumentApproved == !(data.state == "approved") })
        if (dt.length == 0) { cb(false); return }
        ///检查是否有该权限
        let check_ap_res = []
        let _check_ap_params = {
          list: dt,
          DocumentType: "SalesQuoteDistributionPreApply",
          approve_type: "",
          isNotCheckPrivilage: data.state == "approved" ? false : true,
          action_state: data.state == "approved",
        }
        check_ap_res = await commonController.methods.checkApprovePrivilige(_check_ap_params, this)
        if (check_ap_res.notPriviligeIdList.length > 0 || check_ap_res.approveStatusIdList.length == 0) {
          this.msgToasts("抱歉，暂无审批权限！", "error")
          cb(false)
          return
        }
        p.approved = {}
        p.approved.data = dt
        p.approved.local_username = this.$global.global_data.local_username
        p.approved.approveStatusIdList = check_ap_res.approveStatusIdList
        if (data.state == "approved") {
          let _reSetData = _.map(
            data.selected_items,
            (t) => { return { dataAreaId: t.dataAreaId, ItemId: t.ItemId, status: 0, DocumentType: "SalesQuoteDistributionPre" } }
          )
          p.approved.reSetStatusPreDistributionList = _.uniqWith(_reSetData, _.isEqual)
          renew_dt = _.map(data.selected_items, (t) => { return { id: t.id } })
        }
        await commonController.methods.saveUserConfirmAction(`${data.state}_confirm`, 'PreDistributionChangedApply', data, this)
      }

      let rt = await PreDistributionController.methods.savePreDistributionApply(p, renew_dt)
      if (rt) {
        if (data.state == "delete") {
          this.$refs.PreDistributionApplyTable1.RemoveItems(data.selected_items)
          this.$refs.PreDistributionApplyTable2.SetData([])
        }
        else
          await this.on_query(this.$refs.PreDistributionApplyTable1.SetData, false)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(false)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    ///物料下拉
    VendersRemoteMethod(query) {
      let dt = this.$store.state.biz_data.baseData.Vender
      if (query != "") {
        dt = _.filter(dt, (t) => {
          if (_.includes(t.AccountNum, query) || _.includes(t.SEI_Name, query))
            return { value: t.AccountNum, label: t.AccountNum + ":" + t.SEI_Name }
        })
      }
      dt = _.map(_.slice(dt, 0, 100), (t) => {
        return { value: t.AccountNum, label: t.AccountNum + ":" + t.SEI_Name }
      })

      this.VendersOptions = dt
      if (this.SelectedAccountNumData.length > 0) {
        for (var i in this.SelectedAccountNumData) {
          if (!_.some(this.VendersOptions, { value: this.SelectedAccountNumData[i] })) {
            let m = _.find(this.$store.state.biz_data.baseData.Vender, { AccountNum: this.SelectedAccountNumData[i] })
            this.VendersOptions.unshift({ value: m.AccountNum, label: m.AccountNum + ":" + m.SEI_Name })
          }
        }
      }
    },
    //查询物料
    async QueryPreDistribution() {
      this.isBusy2 = true
      this.ItemId = _.trim(this.ItemId)
      this.NameAlias = _.trim(this.NameAlias)
      let p = { is_deleted: { "=": 0 } }
      if (this.ItemId != "") p.ItemId = { "=": this.ItemId }
      if (this.NameAlias != "") p.NameAlias = { "like": "%" + this.NameAlias + "%" }
      let _result = await PreDistributionController.methods.getPreDistribution(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.filter(_.cloneDeep(_result[0]), (t) => { return t.fcCheckDocumentApproved })
        this.$refs.PreDistributionApplyTable3.SetData(_.orderBy(dt, ["id"], ["desc"]))
      }

      this.isBusy2 = false
    },
    MainAddVendInto() {
      let newItems = []
      let invent_m = this.$refs.PreDistributionApplyTable1.GetCurrentItem()
      if (!invent_m) {
        this.msgToasts("请选择物料！", "info")
        return
      }
      _.each(this.MainSelectedAccountNumData, (num) => {
        let m = {}
        m.id = ""
        m.ItemId = invent_m.ItemId
        m.NameAlias = invent_m.NameAlias
        m.AccountNum = num
        let vm = _.find(this.$store.state.biz_data.baseData.Vender, { AccountNum: num })
        m.AccountName = vm.SEI_Name
        m.dataAreaId = this.dataAreaId
        m.PreDistributionId = ""
        if (_.findIndex(this.$refs.PreDistributionApplyTable2.my_data, { AccountNum: num }) < 0) {
          newItems.push(m)
        }
      })
      this.$refs.PreDistributionApplyTable2.AppendItems(newItems)
    },
    ///分配状态切换
    async edit_state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      let v = await this.msgModal(this.$t("notify.is_continue"))
      if (!v) { cb(false); return }
      if (data.state === "deleted") {
        let main_m = this.$refs.PreDistributionApplyTable1.GetCurrentItem()
        if (main_m.fcCheckDocumentApproved) {
          this.msgToasts("已审批数据不能执行该操作！", "info")
          cb(false)
          return
        }
        this.$refs.PreDistributionApplyTable2.RemoveItems(data.selected_items)
      }
    },
    ///明细行输入事件
    edit_distribution_on_input(data) {
      if (data.field.key == "DistributionRate") {
        let lt = _.each(_.cloneDeep(this.$refs.PreDistributionApplyTable2.my_data), (t) => {
          if (!t.DistributionRate) {
            t.DistributionRate = 0
          }
          else {
            t.DistributionRate = parseFloat(t.DistributionRate)
          }
        })
        let total_rate = _.sumBy(lt, "DistributionRate")
        if (total_rate > 100) {
          let _rate = 100 - (total_rate - data.item.DistributionRate)
          data.item.DistributionRate = _rate
        }
      }
    },
    async MainSaveData(cb) {
      //数据验证
      let msg = "", pm = {}, p = { add: [], edit: [] }, items = []
      let detail_data = this.$refs.PreDistributionApplyTable2.my_data
      if (detail_data.length == 0) {
        cb(null)
        return
      }

      let mt = this.$refs.PreDistributionApplyTable1.GetCurrentItem()
      if (mt.fcCheckDocumentApproved == true) {
        this.msgToasts("已审批数据不能执行该操作！", "info")
        cb(false)
        return
      }
      for (var k in pm) {
        if (_.startsWith(k, "_")) delete pm[k]
      }
      let require_fileds = _.map(_.filter(this.distribution_fields, { required: true }), (t) => { return t })
      _.each(detail_data, (t) => {
        let m = _.cloneDeep(t)
        for (var k in m) {
          if (_.startsWith(k, "_")) delete m[k]
        }
        for (var i in require_fileds) {
          let fm = require_fileds[i]
          if (msg == "" && m[fm.key] == "") {
            msg = fm.label + "不能为空！"
          }
        }
        items.push(m)
      })
      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }
      pm.id = mt.id
      pm.Description = this.MainApplyDescription
      pm.DistributionJson = JSON.stringify(items)
      mt.Description = this.MainApplyDescription
      mt.DistributionJson = JSON.stringify(items)
      p.edit.push(pm)
      p.documentCreateByUsername = this.$global.global_data.local_username
      let rt = await PreDistributionController.methods.savePreDistributionApply(p)
      if (rt) {
        await this.on_query(this.$refs.PreDistributionApplyTable1.SetData, false)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true, true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    //#endregion

    //#region 新建分配变更申请相关
    async getPreDetail(old, current) {
      if (current) {
        let items = []
        let _result = await PreDistributionController.methods.getPreDistributionDetail({ PreDistributionId: current.id })
        if (!_.isNull(_result) && _result && _result.length > 0)
          _.each(_.orderBy(_result[0], ["id"], ["asc"]), (t) => {
            t.ItemId = current.ItemId
            t.NameAlias = current.NameAlias
            t.dataAreaId = current.dataAreaId
            t.id = ""
            items.push(t)
          })
        this.$refs.PreDistributionApplyTable4.SetData(items)

      }
    },
    AddVendInto() {
      let newItems = []
      let invent_m = this.$refs.PreDistributionApplyTable3.GetCurrentItem()
      if (!invent_m) {
        this.msgToasts("请选择物料！", "info")
        return
      }
      _.each(this.SelectedAccountNumData, (num) => {
        let m = {}
        m.id = ""
        m.ItemId = invent_m.ItemId
        m.NameAlias = invent_m.NameAlias
        m.AccountNum = num
        let vm = _.find(this.$store.state.biz_data.baseData.Vender, { AccountNum: num })
        m.AccountName = vm.SEI_Name
        m.dataAreaId = this.dataAreaId
        m.PreDistributionId = ""
        if (_.findIndex(this.$refs.PreDistributionApplyTable4.my_data, { AccountNum: num }) < 0) {
          newItems.push(m)
        }
      })
      this.$refs.PreDistributionApplyTable4.AppendItems(newItems)
    },
    ///分配状态切换
    new_state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      if (data.state === "deleted") {
        this.$refs.PreDistributionApplyTable4.RemoveItems(data.selected_items)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
      }
    },
    ///明细行输入事件
    distribution_on_input(data) {
      if (data.field.key == "DistributionRate") {
        let lt = _.each(_.cloneDeep(this.$refs.PreDistributionApplyTable4.my_data), (t) => {
          if (!t.DistributionRate) {
            t.DistributionRate = 0
          }
          else {
            t.DistributionRate = parseFloat(t.DistributionRate)
          }
        })
        let total_rate = _.sumBy(lt, "DistributionRate")
        if (total_rate > 100) {
          let _rate = 100 - (total_rate - data.item.DistributionRate)
          data.item.DistributionRate = _rate
        }
      }
    },
    ///保存分配详情
    async SaveData(cb) {
      //数据验证
      let msg = "", pm = {}, p = { add: [], edit: [] }, items = []
      let detail_data = this.$refs.PreDistributionApplyTable4.my_data
      if (detail_data.length == 0) {
        cb(null)
        return
      }

      let require_fileds = _.map(_.filter(this.distribution_fields, { required: true }), (t) => { return t })
      _.each(detail_data, (t) => {
        let m = _.cloneDeep(t)
        for (var k in m) {
          if (_.startsWith(k, "_")) delete m[k]
        }
        for (var i in require_fileds) {
          let fm = require_fileds[i]
          if (msg == "" && m[fm.key] == "") {
            msg = fm.label + "不能为空！"
          }
        }
        pm = { ItemId: m.ItemId, NameAlias: m.NameAlias, dataAreaId: m.dataAreaId }
        delete m.id
        delete m.ItemId
        delete m.NameAlias
        delete m.dataAreaId
        items.push(m)
      })
      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }
      pm.Description = this.ApplyDescription
      pm.DistributionJson = JSON.stringify(items)
      p.add.push(pm)
      p.documentCreateByUsername = this.$global.global_data.local_username
      let rt = await PreDistributionController.methods.savePreDistributionApply(p)
      if (rt) {
        await this.on_query(this.$refs.PreDistributionApplyTable1.SetData, false)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true, true)
        this.SelectedAccountNumData = []
        this.$refs.PreDistributionApplyTable4.SetData([])
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    //#endregion

    //#region 附件
    async on_cell_button_click(data) {
      this.isShowUpload = !data.item.fcCheckDocumentApproved //已审核数据不能修改附件
      this.current_accessory = data.item
      if (data.field.key == "Accessory") {
        this.accessoryVisible = true
      }
    },
    dialogOpened() {
      this.$refs.refAccessory.getAccessory(this.current_accessory.Accessory, this.current_accessory.ItemId)
    },
    async dialogClosed() {
      if (this.current_accessory && this.current_accessory.Accessory && !this.current_accessory.fcCheckDocumentApproved) {
        let m = { id: this.current_accessory.id, Accessory: this.current_accessory.Accessory }, ml = []
        if (m.id && m.id != "") ml.push(m)
        this.current_accessory.AccessoryCount = JSON.parse(this.current_accessory.Accessory).length
        await PreDistributionController.methods.savePreDistributionApply({ edit: ml, documentCreateByUsername: this.$global.global_data.local_username })
      }
    },
    async setAccessory(data) {
      this.current_accessory.Accessory = data
      await this.dialogClosed()
    }
    //#endregion
  },
}
</script>
<style>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.bom .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: #1138e1b3;
  color: #fff;
}

.hb_table_pre_distri_apply_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 85rem;
}

.hb_table_pre_distri_apply_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 80rem;
}

.bom .el-card__body,
.el-main {
  padding: 0px;
}

.bom .el-drawer__header {
  font-size: 1.1rem;
  color: black;
  padding-left: 0.5rem;
}
</style>
